module.exports = __webpack_public_path__ + "assets/1-vp-of-sales-job-description.cbc9b2df.png";